import { NotificationType } from '@/repositories/notification.repository';
import { useMutation, useQuery } from '@tanstack/react-query';
import notificationRepository from '../repositories/notification.repository';

export function useGetNotificationByType(type: NotificationType) {
  return useQuery({
    queryKey: ['notification', 'get', type],
    queryFn: () => notificationRepository.getNotificationByType(type),
    gcTime: 0,
  });
}

export function useDismissNotificaiton(notificationId: string) {
  return useMutation({
    mutationFn: () => notificationRepository.dismissNotification(notificationId),
  });
}
